import React, { useState } from "react";
import {
  FiActivity, FiGitMerge, FiDroplet, FiWind,
  FiSettings, FiCheckSquare, FiLayers, FiShield,
  FiAlertTriangle, FiCpu, FiFileText
} from "react-icons/fi";
import { DashboardHeader } from "../../components/Shared";
import { stpDummyData } from "../../Data/StpData";

import StpOverviewPanel    from "./panels/StpOverviewPanel";
import StpProcessFlowPanel from "./panels/StpProcessFlowPanel";
import StpInletPanel       from "./panels/StpInletPanel";
import StpAerationPanel    from "./panels/StpAerationPanel";
import StpPumpPanel        from "./panels/StpPumpPanel";
import StpOutletPanel      from "./panels/StpOutletPanel";
import StpSludgePanel      from "./panels/StpSludgePanel";
import StpCompliancePanel  from "./panels/StpCompliancePanel";
import StpAlertsPanel      from "./panels/StpAlertsPanel";
import StpAiPanel          from "./panels/StpAiPanel";
import StpReportsPanel     from "./panels/StpReportsPanel";

import "./StpDashboard.css";

const TABS = [
  { id: "overview",    label: "Overview",          icon: FiActivity      },
  { id: "process",     label: "Process Flow",       icon: FiGitMerge      },
  { id: "inlet",       label: "Inlet",              icon: FiDroplet       },
  { id: "aeration",    label: "Aeration",           icon: FiWind          },
  { id: "pumps",       label: "Pumps & Motors",     icon: FiSettings      },
  { id: "outlet",      label: "Outlet Quality",     icon: FiCheckSquare   },
  { id: "sludge",      label: "Sludge",             icon: FiLayers        },
  { id: "compliance",  label: "Compliance",         icon: FiShield        },
  { id: "alerts",      label: "Alerts",             icon: FiAlertTriangle },
  { id: "ai",          label: "AI & Optimization",  icon: FiCpu           },
  { id: "reports",     label: "Reports",            icon: FiFileText      },
];

const StpDashboard = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const d = stpDummyData;

  const criticalCount = d.alerts.filter(a => a.severity === "Critical" && !a.acknowledged).length;

  return (
    <div className="fm-container">
      <DashboardHeader currentSolutionType="stp" />

      {/* Tab Bar */}
      <div className="fm-tab-bar">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`fm-tab ${activeTab === tab.id ? "fm-tab-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <tab.icon size={15} />
            {tab.label}
            {tab.id === "alerts" && criticalCount > 0 && (
              <span className="fm-tab-badge">{criticalCount}</span>
            )}
          </button>
        ))}
      </div>

      {/* Panel */}
      <div className="fm-panel">
        {activeTab === "overview"   && <StpOverviewPanel    d={d} />}
        {activeTab === "process"    && <StpProcessFlowPanel d={d} />}
        {activeTab === "inlet"      && <StpInletPanel       d={d} />}
        {activeTab === "aeration"   && <StpAerationPanel    d={d} />}
        {activeTab === "pumps"      && <StpPumpPanel        d={d} />}
        {activeTab === "outlet"     && <StpOutletPanel      d={d} />}
        {activeTab === "sludge"     && <StpSludgePanel      d={d} />}
        {activeTab === "compliance" && <StpCompliancePanel  d={d} />}
        {activeTab === "alerts"     && <StpAlertsPanel      d={d} />}
        {activeTab === "ai"         && <StpAiPanel          d={d} />}
        {activeTab === "reports"    && <StpReportsPanel     d={d} />}
      </div>
    </div>
  );
};

export default StpDashboard;
